export default __webpack_public_path__ + "static/media/data_setting_12.c2f1f966.png";